import { countryLocaleMappings } from '../constants/dataConstants';
export const NumberFormatter = (
  countryCode: string,
  amount: number,
  allowRounding: boolean = false
) => {
  const locale = countryLocaleMappings[countryCode] || 'en-US';

  if (allowRounding) {
    return Math.round(amount)?.toLocaleString(locale, {
      maximumFractionDigits: 0,
    });
  }

  return amount?.toLocaleString(locale);
};

export const FormatLocalizedNumber = (
  countryCode: string,
  amount: number | string | undefined,
  allowRounding: boolean = false
): string => {
  if (amount == null || amount === '-') return '-';

  const locale = countryLocaleMappings[countryCode] || 'en-US';
  const num = Number(amount);

  if (isNaN(num)) return '-';

  if (allowRounding) {
    return Math.round(num).toLocaleString(locale, {
      maximumFractionDigits: 0,
    });
  }

  const truncated = Math.trunc(parseFloat((num * 100).toFixed(8))) / 100;
  return truncated.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
